import { localStorage } from 'dibs-browser-storage';

export const AUTO_MODAL_SHOWN = 'autoModalShown';
//Same Pdp or Exit Pdp modals could be shown each 15days
const autoPdpModalShownInterval = 1296000000;

export const setModalShown = () =>
    localStorage.setItem(AUTO_MODAL_SHOWN, { timestamp: Date.now() });

export const wasModalShown = () => {
    const { timestamp } = localStorage.getItem(AUTO_MODAL_SHOWN) || {};
    return !!timestamp && Date.now() - timestamp <= autoPdpModalShownInterval;
};
